import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { theme } from '../../../../../styles/theme';
import { getQueryTypePagePath } from '../../../../../utils';
import { queryTypeConfigLookup } from '../../../../../utils/queryTypeLookup';
import { SvgIcon } from '../../../../../components/Icon';
import { appRoutes } from '../../../../../path';
import { IRecentActivity } from '../types';
import { UnreachableCaseError } from 'ts-essentials';

interface IProps {
  recentActivity: IRecentActivity;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 2px;
`;
const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  column-gap: 8px;
  width: 100%;
  color: ${theme.colors.secondary800};
  font: inherit;
  transition: color 0.2s ease-in-out;
  &:hover {
    color: ${theme.colors.mainBlue};
  }
`;
const Label = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 22px;
`;

const DeletedItem = styled.div`
  display: flex;
  column-gap: 8px;
  align-items: center;
`;

const RecentActivityTableDisplay = ({ recentActivity }: IProps) => {
  switch (recentActivity.__typename) {
    case 'RecentAnalysisVisit': {
      const { analysisId, queryType, display } = recentActivity;
      const url = getQueryTypePagePath(queryType, analysisId);
      const { icon } = queryTypeConfigLookup[queryType];

      return (
        <Container>
          <StyledLink to={url}>
            <SvgIcon
              name={icon}
              width={16}
              height={16}
              customFill="currentColor"
            />
            <Label>{display}</Label>
          </StyledLink>
        </Container>
      );
    }
    case 'RecentDashboardVisit': {
      const { dashboardBaseId, display } = recentActivity;

      return (
        <Container>
          {recentActivity.isDeleted ? (
            <DeletedItem>
              <SvgIcon
                name="dashboard"
                width={16}
                height={16}
                customFill="currentColor"
              />
              <Label>{display} (Deleted)</Label>
            </DeletedItem>
          ) : (
            <StyledLink to={appRoutes.dashboard.generateLink(dashboardBaseId)}>
              <SvgIcon
                name="dashboard"
                width={16}
                height={16}
                customFill="currentColor"
              />
              <Label>{display}</Label>
            </StyledLink>
          )}
        </Container>
      );
    }
    default:
      throw new UnreachableCaseError(recentActivity);
  }
};

export default RecentActivityTableDisplay;
